import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import MaterialTable from "material-table";
import { IconButton, Tooltip } from "@material-ui/core";
import Icon from "@jll/icon";
import styles from "./styles";
import { Link } from "react-router-dom";
import {
  tableStyle,
  tableOptions,
  tableIcons,
} from "../../../../Component/Table/tableCommonStyles";

import { useTranslation } from "react-i18next";
import { formatDate } from "../../../../Utilities/Functions";

const useStyles = makeStyles(styles);

const DocumentRequestTable = ({ documentRequests = [], onRowViewClick }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [tableData, setTableData] = useState([]);

  const GENERIC_REQUEST = t(
    "labels.record.documentRequest.steps.requestTypeStep.genericRequest",
  );
  const SPECIFIC_REQUEST = t(
    "labels.record.documentRequest.steps.requestTypeStep.specificRequest",
  );
  useEffect(() => {
    const tableData = [];
    for (let dr of documentRequests) {
      const {
        id,
        request_type,
        client_entity_id,
        clientRecordName,
        entity_id,
        request,
        status,
        created_date,
        created_by_user_name,
        updated_by_user_name,
        updated_by_user_email,
        updated_date,
      } = dr;
      const requestType =
        request_type === "1" ? GENERIC_REQUEST : SPECIFIC_REQUEST;
      const sourceRecordName =
        client_entity_id !== entity_id ? (
          <div>
            <i>
              {t("labels.record.documentRequest.table.headers.requestedFrom")}
              &nbsp;
              <Link to={{ search: `?id=${client_entity_id}` }} target="_blank">
                {clientRecordName}
              </Link>
            </i>
          </div>
        ) : (
          ""
        );
      const { clientUser } = request;
      tableData.push({
        id,
        requestType,
        sourceRecordName,
        clientEntityId: client_entity_id,
        entityId: entity_id,
        requestedBy: created_by_user_name,
        requestedDate: formatDate(created_date),
        clientUser: `${clientUser.username}(${clientUser.userEmail})`,
        status: t(`labels.record.documentRequest.statuses.${status}`),
        lastUpdatedByUser: `${updated_by_user_email || "-"}`,
        lastUpdatedOn: formatDate(updated_date),
      });
    }
    setTableData(tableData);
  }, [documentRequests]);

  return (
    <div className={classes.tableWrapper}>
      <MaterialTable
        style={tableStyle}
        icons={tableIcons}
        options={tableOptions}
        isLoading={false}
        data={tableData}
        localization={{
          header: {
            actions: t("labels.common.table.actions"),
          },
          body: {
            emptyDataSourceMessage: t("labels.common.table.noRecordsFound"),
          },
        }}
        columns={[
          {
            title: t("labels.record.documentRequest.table.headers.requestType"),
            field: "request_type",
            render: (rowData) => {
              return (
                <div>
                  {rowData.requestType}
                  {rowData.sourceRecordName}
                </div>
              );
            },
            cellStyle: {
              position: "initial",
            },
          },
          {
            title: t("labels.record.documentRequest.table.headers.requestedBy"),
            field: "requestedBy",
          },
          {
            title: t(
              "labels.record.documentRequest.table.headers.requestedDate",
            ),
            field: "requestedDate",
          },
          {
            title: t("labels.record.documentRequest.table.headers.clientUsers"),
            field: "clientUser",
          },
          {
            title: t("labels.record.documentRequest.table.headers.updatedBy"),
            field: "lastUpdatedByUser",
          },
          {
            title: t("labels.record.documentRequest.table.headers.updatedOn"),
            field: "lastUpdatedOn",
          },
          {
            title: t("labels.record.documentRequest.table.headers.status"),
            field: "status",
          },
        ]}
        actions={[
          {
            icon: "ViewColumn",
            tooltip: t(
              "labels.record.documentRequest.table.actions.viewRequest",
            ),
            onClick: (record) =>
              onRowViewClick(
                documentRequests.find((dr) => dr.id === record.id),
              ),
          },
        ]}
        components={{
          Action: (props) => {
            if (props.data.parentId) {
              return null;
            }
            switch (props.action.icon) {
              case "ViewColumn":
                return (
                  <Tooltip
                    title={t(
                      "labels.record.documentRequest.table.actions.viewRequest",
                    )}
                    placement="bottom"
                  >
                    <IconButton
                      className={classes.actionIcons}
                      onClick={(event) => props.action.onClick(props.data)}
                    >
                      <Icon
                        className="fas fa-address-card"
                        style={{ fontSize: 16 }}
                      />
                    </IconButton>
                  </Tooltip>
                );
              default:
                return null;
            }
          },
        }}
      />
    </div>
  );
};

export default DocumentRequestTable;
